enum NavigationApp {
  MPC = "MPC",
  MPO = "MPO",
  MUS = "MUS",
  MTC = "MTC",
}

export default NavigationApp;
